import TextSpinner from './text-spinner';

export * from './text-spinner';
export default TextSpinner;
